export function normalizePhilippineMobile(value?: string): string | undefined {
  if (!value) return undefined;
  const digits = value.replace(/\D/g, '');
  if (digits.startsWith('63') && digits.length === 12) return `0${digits.slice(2)}`;
  if (digits.startsWith('09') && digits.length === 11) return digits;
  return value.trim() || undefined;
}

export function maskMobile(value?: string): string {
  if (!value) return '';
  const normalized = normalizePhilippineMobile(value) ?? value;
  return normalized.length >= 7 ? `${normalized.slice(0, 4)}-***-${normalized.slice(-4)}` : '***';
}

export function customerCode(): string {
  return `CUS-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
}
